import { type IHttpClient } from '@wix/yoshi-flow-editor';
import {
  getUserConnectStatus,
  getUser,
} from '@wix/ambassador-adsense-v1-adsense-user/http';
import type {
  GetUserConnectStatusResponse,
  GetUserResponse,
} from '@wix/ambassador-adsense-v1-adsense-user/types';

export const fetchUser = async (
  httpClient: IHttpClient,
  instanceId: string,
): Promise<GetUserConnectStatusResponse> => {
  try {
    const { data } = await httpClient.request<GetUserConnectStatusResponse>(
      getUserConnectStatus({ instanceId }),
    );
    return data;
  } catch (error) {
    console.error('Error fetching user:', error);
    throw new Error('Failed to fetch user data');
  }
};

export const fetchCachedUser = async (
  httpClient: IHttpClient,
  instanceId: string,
): Promise<GetUserResponse> => {
  try {
    const { data } = await httpClient.request<GetUserResponse>(
      getUser({ instanceId }),
    );
    return data;
  } catch (error) {
    console.error('Error fetching cached user:', error);
    throw new Error('Failed to fetch cached user data');
  }
};
